export default "__VITE_ASSET__DDQ23WC8__"